import {HttpAxiosRequest} from 'src/http/httpAxiosBase'
import {BaseResponse, EntityListWithPagination, PaginacionRequest} from '../../types'
import {
    GroupCoordinadorViewDTO,
    GroupFilterDTO,
    GroupInsertDTO,
    GroupSectorComercialViewDTO,
    GroupUserListResponseDTO,
    GroupUserViewDTO,
    GroupViewDTO
} from '../../types/group/groupData'
import {SchemaFiltroUsuarioGrupo} from "../../pages/admin/grupos/GroupForm";

export const HttpGroup = {
    getEndpoint: (url: string) => `grupos${url}`,

    getGroupList: (
        paginacion: PaginacionRequest,
        filter: GroupFilterDTO
    ): Promise<EntityListWithPagination<GroupViewDTO>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpGroup.getEndpoint(''), {...paginacion, ...filter})
    },

    insertGroup: (group: GroupInsertDTO): Promise<number> => {
        return HttpAxiosRequest.post(HttpGroup.getEndpoint(''), group)
    },

    updateGroup: (groupId: number, group: GroupInsertDTO): Promise<BaseResponse> => {
        return HttpAxiosRequest.put(HttpGroup.getEndpoint(`/${groupId}`), group)
    },

    deactivateGroup: (groupId: number) => {
        return HttpAxiosRequest.delete(HttpGroup.getEndpoint(`/${groupId}`))
    },

    activateGroup: (groupId: number) => {
        return HttpAxiosRequest.post(HttpGroup.getEndpoint(`/${groupId}/activar`), {})
    },

    getSectoresComercialPorGrupo: (groupId: number): Promise<GroupSectorComercialViewDTO[]> => {
        return HttpAxiosRequest.get(HttpGroup.getEndpoint(`/${groupId}/sectores-comerciales`))
    },

    updateSectoresComercialPorGrupo: (groupId: number, sectores: number[]) => {
        return HttpAxiosRequest.post(HttpGroup.getEndpoint(`/${groupId}/sectores-comerciales`), sectores)
    },

    getGruposCoordinadores: (codPais: number, codSistema: number): Promise<GroupCoordinadorViewDTO[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpGroup.getEndpoint(`/coordinadores`), {
            codPais,
            codSistema
        })
    },

    getUsersByGroup: (groupId: number, params?: SchemaFiltroUsuarioGrupo): Promise<GroupUserListResponseDTO> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpGroup.getEndpoint(`/${groupId}/usuarios`),
            {...params})
    },

    updateGroupUsers: (groupId: number, userIdList: number[]) => {
        return HttpAxiosRequest.post(HttpGroup.getEndpoint(`/${groupId}/usuarios`), userIdList)
    },
}
